import type { NavigatorProviderRequestStatus } from "../types";
import { formatDateTime } from "../intakeUtils";

type ProviderRequestHistoryProps = {
  history: NavigatorProviderRequestStatus[];
};

function requestTime(request: NavigatorProviderRequestStatus): string | null {
  return request.forwardedAt || request.submittedAt || request.createdAt;
}

export default function ProviderRequestHistory({
  history,
}: ProviderRequestHistoryProps) {
  return (
    <section className="cn-case-detail-card cn-provider-history">
      <div className="cn-case-detail-card-header">
        <div>
          <h2>Provider request history</h2>
          {history.length ? (
            <p className="cn-case-detail-muted">Most recent first</p>
          ) : null}
        </div>
      </div>

      {history.length ? (
        <ol className="cn-provider-history-list">
          {history.map((request) => (
            <li key={request.requestId}>
              <strong>
                {request.familyDoctorName || "Provider not recorded"}
              </strong>
              <span>{request.clinicName || "Clinic not recorded"}</span>
              <span>{request.statusLabel || request.statusName || "—"}</span>
              <span>{formatDateTime(requestTime(request))}</span>
              {request.decisionAt ? (
                <span>Decision {formatDateTime(request.decisionAt)}</span>
              ) : null}
              {request.cancelledAt ? (
                <span>Cancelled {formatDateTime(request.cancelledAt)}</span>
              ) : null}
              {request.autoExpiredAt ? (
                <span>Expired {formatDateTime(request.autoExpiredAt)}</span>
              ) : null}
              {request.attachmentCompletedAt ? (
                <span>
                  Attachment completed{" "}
                  {formatDateTime(request.attachmentCompletedAt)}
                </span>
              ) : null}
            </li>
          ))}
        </ol>
      ) : (
        <p className="cn-case-detail-muted">
          No provider request has been recorded for this case.
        </p>
      )}
    </section>
  );
}
